import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_TYPE = 'website';

function MetaOpenGraph({
  property,
  content: passedContent
}) {
  let content;

  if (passedContent) {
    content = passedContent;
  } else if (property === 'type') {
    content = DEFAULT_TYPE;
  } else if (property === 'title') {
    content = document.title;
  } else if (property === 'url') {
    content = window.location.href;
  }

  if (!content) {
    console.error(`MetaOpenGraph: content required to render ${property} tag`);
  }

  return /*#__PURE__*/_jsx("meta", {
    property: `og:${property}`,
    content: content,
    "data-test-id": `${property}-og`
  });
}

export default MetaOpenGraph;